import {
	useDayjs,
	useLanguageConfig,
	useLogoutControl,
	usePreventIOSAutozoom,
	useSentryConfig,
	useYupConfig
} from './hooks';

function Config() {
	useLanguageConfig();
	useYupConfig();
	useDayjs();
	useLogoutControl();
	useSentryConfig();

	usePreventIOSAutozoom();

	return null;
}

export default Config;
